<template>
  <v-dialog persistent v-bind="[$attrs, $props]" width="1300">
    <v-form ref="form" class="py-10 px-11 white">
      <v-row>
        <v-col cols="11">
          <p class="form__title primary--text mb-5">
            {{ title }}
          </p>
        </v-col>
        <v-col cols="1" class="text-end">
          <BaseButton text icon @click="$emit('close')" class="justify-center">
            <v-icon size="17" color="gray" class="justify-center">
              fa-times
            </v-icon>
          </BaseButton>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
            <ModalityPermissionsTable ref="table" :economicGroupId="economicGroupId" :targetAPI="targetAPI" :targetId="targetId" />
        </v-col>
      </v-row>
      <v-row>
        <v-spacer />
        <v-col cols="3">
          <BaseButton
            v-html="'SALVAR'"
            class="secondary"
            width="100%"
            @click="submit"
            style="margin-top:10px"
          />
        </v-col>
      </v-row>
    </v-form>
  </v-dialog>
</template>
<script>
import ModalityPermissionsTable from "./ModalityPermissionsTable.vue"
export default {
  components: {
    ModalityPermissionsTable
  },
  methods: {
    submit() {
        this.$refs.table.save().then(()=>this.$emit('close'));
    }
  },
  props: {
    title: {type: String, default:"PERMISSÕES" },
    // Id do grupo economico dessa lista de permissões.
    economicGroupId: { type: String, required: true },
    // Id do usuário/escritório dessa lista de permissões.
    targetId: { type: String, required: true },
    // Determina qual endpoint será usado para se comunicar com o servidor.
    targetAPI: { type: String, required: true }
  }
};
</script>
